import { CredentialManager, type ClientOptions } from "#lib/api/api.js";
import { handlePageLoadError } from "#lib/api/error.js";
import { newApiClients } from "#lib/client.js";
import { Logger } from "#lib/logging.js";
import { flags } from "#lib/optimizely.js";
import type { LayoutLoadEvent } from "./$types";

export async function load(event: LayoutLoadEvent) {
	try {
		await flags.onReady({ timeout: 2000 });
	} catch (err) {
		Logger.error("Failed to initialize flags, all flags will resolve to false", { err });
	}
	try {
		const options: ClientOptions = {
			credentials: new CredentialManager(event.data.tokens, event.fetch),
			fetch: event.fetch,
		};
		return {
			...newApiClients(options),
			clientOptions: options,
			anonymousSessionId: event.data.anonymousSessionId,
			traceparent: event.data.traceparent,
			flags,
		};
	} catch (e) {
		throw handlePageLoadError(e, event.route.id, event.params);
	}
}
